(function () {
    'use strict';

    a3_cabin_reports.controller('CrewRouteRefreshModalCtrl', CrewRouteRefreshModalCtrl)
    /**
     * @memberof CabinReports
     * @ngdoc controller
     * @name CrewRouteRefreshModalCtrl
     * @description 
     * 
     * @ngInject
     */

    function CrewRouteRefreshModalCtrl($scope, $filter, $uibModalInstance, crewroute, crewRouteDuty, dutyNo, dutyDay, forCurrentDay, 
                    InfoAPIService, FlightSessionFactory, CourseFactory, AirportContactFactory, CrewRouteFactory, LuggageComplianceFactory,
                    GroundServicesFactory, AircraftDifferencesFactory, AirportHotelFactory, TimeLogFactory, CrewCallFactory, PreviousDutyFactory,
                     CampaignFactory, AimsCrewMemosFactory, FlightDelaysFactory, CustomerEventHistoryFactory, FlightServiceEventsFactory,FlightOrdersFactory, SettingsMain ) 
    {
        //timer
        var t0 = performance.now();
        var timeLog = "RefreshFlight: ";
        var tFrom = 0;
        var tTo = 0;
        // tFrom = performance.now();
        // //do smth
        // tTo = performance.now();
        // timeLog = timeLog + " | smthTime: " + (tTo-tFrom); 
        var isShopInTheCloudEnable = SettingsMain.getIsShopInTheCloudEnable();
        $scope.isRefreshing = true;
        $scope.refreshResultsVisible = false;
        $scope.error = false;
        $scope.sync = false;
        $scope.collapse = collapse
        $scope.close = close;
        $scope.crewroute = crewroute;
        $scope.crewRouteDuty = crewRouteDuty;
        $scope.crewRouteGeneral = {statuses: [], isCollapsed:false};
        
        //For refresh Flight page: forCurrentDay is not null
        if(forCurrentDay){
            //Get only the flights from the current day
            var currentDayDuties = crewroute.filter(function (item) {
                return (item.DutyType == 'Flight'&& item.FlightDate == forCurrentDay)
                    || (item.DutyType == 'Ground'&& item.DutyDate == forCurrentDay);
            });
            crewroute = currentDayDuties;
            $scope.crewroute = currentDayDuties;
            crewRouteDuty.CurrentDutyDate = forCurrentDay;
            
            if(currentDayDuties.some(s=>s.DutyType == 'Flight')){
                $scope.crewRouteGeneral.statuses = [
                    {
                        datatype: "Meals", 
                        status: "PENDING",
                        text: "Pending..."
                    },
                    {
                        datatype: "Campaigns",
                        status: "PENDING",
                        text: "Pending..."
                    },
                    {
                        datatype: "Hotels",
                        status: "PENDING",
                        text: "Pending..."
                    },
                    {
                        datatype: "Airport Contacts",
                        status: "PENDING",
                        text: "Pending..."
                    },
                    {
                        datatype: "Ground Services",
                        status: "PENDING",
                        text: "Pending..."
                    },
                    {
                        datatype: "Aircraft Differences",
                        status: "PENDING",
                        text: "Pending..."
                    },
                    {
                        datatype: "Aims Memos",
                        status: "PENDING",
                        text: "Pending..."
                    },
                    {
                        datatype: "Flight Service Events",
                        status: "PENDING",
                        text: "Pending..."
                    }

                ];
            }
            
        }

        //add DataStatus to each duty
        for (var i = 0; i < crewroute.length; i++) {
            if (crewroute[i].DutyType == 'Flight') {

                crewroute[i].DataStatus = [
                    {
                        datatype: "Flight Status",
                        status: "PENDING",
                        text: "Pending..."
                    },
                    {
                        datatype: "Aircraft Movement",
                        status: "PENDING",
                        text: "Pending..."
                    },
                    {
                        datatype: "Crew Info",
                        status: "PENDING",
                        text: "Pending..."
                    },
                    {
                        datatype: "Crew Contacts",
                        status: "PENDING",
                        text: "Pending..."
                    },
                    {
                        datatype: "Pax Info",
                        status: "PENDING",
                        text: "Pending..."
                    },                  
                    {
                        datatype: "Connections",
                        status: "PENDING",
                        text: "Pending..."
                    },
                    {
                        datatype: "Luggage Info",
                        status: "PENDING",
                        text: "Pending..."
                    },
                    {
                        datatype: "Training Info",
                        status: "PENDING",
                        text: "Pending..."
                    }
                ];

                if(isShopInTheCloudEnable){
                    crewroute[i].DataStatus.push({
                        datatype: "Shop In The Cloud",
                        status: "PENDING",
                        text: "Pending..."
                    })
                }

               
            }
            else if (crewroute[i].DutyType == 'Ground') {
                if (crewroute[i].isTraining) {
                    crewroute[i].DataStatus = [
                        {
                            datatype: "Duty Info",
                            status: "PENDING",
                            text: "Pending..."
                        },
                        {
                            datatype: "Instructors",
                            status: "PENDING",
                            text: "Pending..."
                        },
                        {
                            datatype: "Trainees",
                            status: "PENDING",
                            text: "Pending..."
                        }
                    ]
                }
                else {
                    crewroute[i].DataStatus = [
                        {
                            datatype: "Duty Info",
                            status: "PENDING",
                            text: "Pending..."
                        }
                    ]
                }

            }

        }

        //separate flights and groundDuties 
        var currentFlights = [];
        var currentGroundDuties = [];
        for (var i = 0; i < crewroute.length; i++) {
            if (crewroute[i].DutyType == 'Flight') currentFlights.push(crewroute[i]);
            else if (crewroute[i].DutyType == 'Ground') currentGroundDuties.push(crewroute[i]);

            crewroute[i].isCollapsed = false;
        }
        //get latest info
        InfoAPIService.refreshCrewRoute(crewRouteDuty, function (responseData) {
            tTo = performance.now();
            timeLog = timeLog + " | apiResponseTime: " + (tTo-t0); 

            $scope.isRefreshing = false;
            var response = responseData.data.data;      
            var responseStatuses = {
                meals: false, 
                airportContacts: false, 
                groundServices: false, 
                aircraftDifferences: false, 
                airportHotels: false, 
                campaigns: false,
                crewAimsMemos: false,
                flightServiceEvents: false
            };
            if (forCurrentDay){

                var responseFlightIds = response.Flights.map(x=> x.FlightInfo.FlightId);
                //Update CrewMeals in the current route // only for refresh flight
                if(response.CrewMeals != undefined && response.CrewMeals != null ){
                    
                    tFrom = performance.now();
                    
                    CrewRouteFactory.updateCrewMealsInRoute(dutyNo, dutyDay, response.CrewMeals , responseFlightIds);
                    responseStatuses.meals = true
                    
                    tTo = performance.now();
                    timeLog = timeLog + " | updateCrewMealsInRoute: " + (tTo-tFrom); 
                }
              
                // Update Airport Contacts
                if (response.AirportContacts && response.AirportContacts.length > 0) {
                    tFrom = performance.now();
                    AirportContactFactory.upsertAirportContacts(response.AirportContacts);
                    responseStatuses.airportContacts = true;
                    tTo = performance.now();
                    timeLog = timeLog + " | upsertAirportContacts: " + (tTo-tFrom); 
                }

                // Update ground services
                if (response.GroundServices && response.GroundServices.length > 0) {
                    tFrom = performance.now();
                    GroundServicesFactory.upsertGroundServices(response.GroundServices);
                    responseStatuses.groundServices = true;
                    tTo = performance.now();
                    timeLog = timeLog + " | upsertGroundServices: " + (tTo-tFrom); 
                }
                
                // Update aircraft differences
                if (response.AircraftDifferences && response.AircraftDifferences.length > 0) {
                    tFrom = performance.now();
                    AircraftDifferencesFactory.upsertAircraftDifferences(response.AircraftDifferences);
                    responseStatuses.aircraftDifferences = true;
                    tTo = performance.now();
                    timeLog = timeLog + " | upsertAircraftDifferences: " + (tTo-tFrom); 
                }

                // Update airport hotels
                if (response.AirportHotels && response.AirportHotels.length > 0) {
                    tFrom = performance.now();
                    AirportHotelFactory.upsertAirportHotels(response.AirportHotels);
                    responseStatuses.airportHotels = true;
                    tTo = performance.now();
                    timeLog = timeLog + " | upsertAirportHotels: " + (tTo-tFrom); 
                }

                // Update Aims Crew Memos
                if (response.CrewAimsMemos && response.CrewAimsMemos.length > 0) {
                    tFrom = performance.now();
                    AimsCrewMemosFactory.upsertAimsCrewMemos(response.CrewAimsMemos);
                    responseStatuses.crewAimsMemos = true;
                    tTo = performance.now();
                    timeLog = timeLog + " | upsertAimsCrewMemos: " + (tTo-tFrom); 
                }

                // Update campaigns
                if (response.Campaigns && response.Campaigns.FlightsCampaigns.length > 0) {
                    tFrom = performance.now();
                    CampaignFactory.mergeCampaigns(response.Campaigns);
                    responseStatuses.campaigns = true;
                    tTo = performance.now();
                    timeLog = timeLog + " | mergeCampaigns: " + (tTo-tFrom); 
                }

                // Update Flight Delays
                if (response.FlightDelays && response.FlightDelays.length > 0) {
                    tFrom = performance.now();
                    FlightDelaysFactory.upsertFlightDelays(response.FlightDelays);
                    tTo = performance.now();
                    timeLog = timeLog + " | upsertFlightDelays: " + (tTo-tFrom); 
                }

                //Get Customer Event History - one stop shop
                if (response.OneStopShop && response.OneStopShop.CustomerEventHistory && response.OneStopShop.CustomerEventHistory.length > 0) {
                    tFrom = performance.now();
                    CustomerEventHistoryFactory.refreshPassengerHistory(response.OneStopShop.CustomerEventHistory);
                    tTo = performance.now();
                    timeLog = timeLog + " | mergeCampaigns: " + (tTo-tFrom);
                }

                //Get flight service events
                if (response.FlightServiceEvents && response.FlightServiceEvents.length > 0) {
                    tFrom = performance.now();
                    responseStatuses.flightServiceEvents = true;
                    FlightServiceEventsFactory.upsertEvents(response.FlightServiceEvents);
                    tTo = performance.now();
                    timeLog = timeLog + " | upsertFlightServiceEvents " + (tTo-tFrom);
                }

            }

            //if there are significant changes in crew route user should sync
            tFrom = performance.now();
            var needsSynchCheck = needsSynch(currentFlights, response.Flights, currentGroundDuties, response.GroundDuties);        
            tTo = performance.now();
            timeLog = timeLog + " | needsSynchCheck: " + (tTo-tFrom);
            if (needsSynchCheck) {
                $scope.sync = true;
            }
            else {
                //Manage details info and Update local storage
                if (response.Flights.length) {
                    //Manage crew route statuses
                    tFrom = performance.now();
                    InfoAPIService.updateCrewRouteStatusSetter($scope.crewRouteGeneral.statuses, responseStatuses);
                    tTo = performance.now();
                    timeLog = timeLog + " | updateCrewRouteStatusSetter: " + (tTo-tFrom);

                    tFrom = performance.now();
                    setupFlightInfo(response.Flights);
                    tTo = performance.now();
                    timeLog = timeLog + " | setupFlightInfo: " + (tTo-tFrom);
                    
                    tFrom = performance.now();
                    updateFlights(response.Flights);
                    tTo = performance.now();
                    timeLog = timeLog + " | updateFlights: " + (tTo-tFrom);

                    //Get Flight orders and update the LS - [shop in the cloud]
                    if (isShopInTheCloudEnable && response.RouteOrders && response.RouteOrders.Success 
                        && response.RouteOrders.FlightOrders && response.RouteOrders.FlightIds.length > 0) {
                        tFrom = performance.now();
                        FlightOrdersFactory.upsertFlightOrders(response.RouteOrders.FlightOrders, responseFlightIds);
                        tTo = performance.now();
                        timeLog = timeLog + " | upsertFlightOrders: " + (tTo-tFrom);
                    }

                    //Save training
                    tFrom = performance.now();
                    response.Flights.forEach(function(flight){
                        var trainingCourses = flight.TrainingCourses;
                        if(trainingCourses && trainingCourses.length && flight.FlightInfo){
                            trainingCourses.forEach(function(trainingCourse){
                                CourseFactory.upsertCourse(trainingCourse, function(course) {
                                    FlightSessionFactory.applyTraineeInfoToSession(course, course.Id, new moment(flight.FlightInfo.FlightDate).format("YYYY-MM-DD"), dutyNo, dutyDay, function(session) {
                                    });
                                });
                            });
                        }
                    });
                    tTo = performance.now();
                    timeLog = timeLog + " | SaveTraining: " + (tTo-tFrom);
                    
                }
                if (response.GroundDuties.length) {
                    tFrom = performance.now();
                    setupGroundInfo(response.GroundDuties);
                    tTo = performance.now();
                    timeLog = timeLog + " | setupGroundInfo: " + (tTo-tFrom);
                    tFrom = performance.now();
                    updateGroundDuties(response.GroundDuties);
                    tTo = performance.now();
                    timeLog = timeLog + " | updateGroundDuties: " + (tTo-tFrom);
                }

                $scope.refreshResultsVisible = true;

                tFrom = performance.now();
                CrewRouteFactory.updateRouteLastRefreshDate(dutyNo, dutyDay);
                tTo = performance.now();
                timeLog = timeLog + " | updateRouteLastRefreshDate: " + (tTo-tFrom);

                tTo = performance.now();
                timeLog = timeLog + " | Start-End: " + (tTo-t0);
                TimeLogFactory.timeLogToStorage(timeLog, response.Timelog);
            }
        })
        .catch(function () {
            $scope.error = true;
            $scope.isRefreshing = false;
        });

        /**
         * Checks if crew route has significantly changed and needs sync
         * @memberof CrewRouteRefreshModalCtrl
         * @param {array} currentFlights   Array of current flights
         * @param {array} newFlights       Array of newly fetched flights
         * @param {array} currentGroundDuties  Array of current ground duties
         * @param {array} newGroundDuties      Array of newly fetched ground duties
         */
        function needsSynch(currentFlights, newFlights, currentGroundDuties, newGroundDuties) {
            var sync = false;
            //1.Crew Route may not exist any more
            if (!newFlights.length && !newGroundDuties.length) {
                sync = true;
            }
            //2.Duties may have been added/removed 
            else if ((newFlights.length != currentFlights.length) || (newGroundDuties.length != currentGroundDuties.length)) {
                sync = true;    //different size arrays
            }
            else {   //same size arrays
                if (currentFlights.length && newFlights.length) {                          //compare current with new flights

                    currentFlights = $filter('orderBy')(currentFlights, 'FlightId');
                    newFlights = $filter('orderBy')(newFlights, 'FlightInfo.FlightId');
                    for (var i = 0; i < currentFlights.length; i++) {
                        if (newFlights[i].FlightInfo && currentFlights[i].FlightId != newFlights[i].FlightInfo.FlightId) {
                            sync = true;
                            break;
                        }
                    }
                }

                if (currentGroundDuties.length && newGroundDuties.length) {                  //compare current with new ground duties
                    currentGroundDuties = $filter('orderBy')(currentGroundDuties, 'Id');
                    newGroundDuties = $filter('orderBy')(newGroundDuties, 'Id');
                    for (var i = 0; i < currentGroundDuties.length; i++) {
                        if (currentGroundDuties[i].Id != newGroundDuties[i].Id) {
                            sync = true;
                            break;
                        }
                    }
                }
            }
            return sync;
        }

        /**
         * Updates Flight in Local Storage
         * @memberof CrewRouteRefreshModalCtrl
         * @param {array} newFlights 
         */
        function updateFlights(newFlights) {
            for (var i = 0; i < newFlights.length; i++) {
                InfoAPIService.updateFlightLocalStorage(newFlights[i]);
                InfoAPIService.updatePhiloxeniaQuestions(newFlights[i]);
                LuggageComplianceFactory.updateLuggageComplianceStorage(newFlights[i].LuggageCompliance, newFlights[i].FlightId);
                InfoAPIService.updateCrewCheckIn(newFlights[i]);
                
                //Update previous Duties & phone calls
                //1. First remove all additional info (phone numbers & previous duties) for this flight
                CrewCallFactory.cleanFlightCrewNumbers(newFlights[i].FlightInfo.FlightId);
                PreviousDutyFactory.cleanFlightPreviousDuties(newFlights[i].FlightInfo.FlightId);
                //2. Then save any fetched info
                if( newFlights[i].FlightInfo){
                    var crew = newFlights[i].FlightInfo.crew;
                    CrewCallFactory.saveFlightPhoneNumbers(newFlights[i].FlightInfo.FlightId, crew, newFlights[i].FlightInfo.ScheduledArrival, newFlights[i].FlightInfo.ScheduledDeparture);
                    PreviousDutyFactory.saveFlightPreviousDuties(newFlights[i].FlightInfo.FlightId, crew);
                } 

            }
        }

        /**
         * Updates Flight's Data Status
         * @memberof CrewRouteRefreshModalCtrl
         * @param {array} newFlights 
         */
        function setupFlightInfo(newFlights) {
            newFlights = $filter('orderBy')(newFlights, 'Start', false);
            currentFlights = $filter('orderBy')(currentFlights, 'Start', false);
            
            for (var i = 0; i < newFlights.length; i++) {
                InfoAPIService.updateFlightStatusSetter(newFlights[i], currentFlights[i].DataStatus);
            }
        }

        /**
         * Updates Ground Duty's Data Status
         * @memberof CrewRouteRefreshModalCtrl
         * @param {array} newGroundDuties 
         */
        function setupGroundInfo(newGroundDuties) {
            newGroundDuties = $filter('orderBy')(newGroundDuties, 'Start', false);
            currentGroundDuties = $filter('orderBy')(currentGroundDuties, 'Start', false);

            for (var i = 0; i < newGroundDuties.length; i++) {
                InfoAPIService.updateGroundStatusSetter(newGroundDuties[i], currentGroundDuties[i].DataStatus);
            }
        }

        /**
         * Updates Ground Duty in Local Storage
         * @memberof CrewRouteRefreshModalCtrl
         * @param {array} newFlights 
         */
        function updateGroundDuties(newGroundDuties) {
            for (var i = 0; i < newGroundDuties.length; i++) {
                InfoAPIService.updateGroundDutyLocalStorage(newGroundDuties[i]);
            }
        }

        /**
         * Shows Details 
         * @memberof CrewRouteRefreshModalCtrl
         * @param {object} duty 
         */
        function collapse(duty) {
            if (!$scope.isRefreshing && $scope.refreshResultsVisible)
                duty.isCollapsed = !duty.isCollapsed;
        }

        /**
         * Closes the modal
         * @memberof CrewRouteRefreshModalCtrl
         */
        function close() {
            $uibModalInstance.close({ sync: $scope.sync, refresh: $scope.refreshResultsVisible });
        }

    }
})();